import { MailOutlined } from "@ant-design/icons";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import { FaUser } from "react-icons/fa";
import React, { useEffect, useState } from "react";
import { MdArchive, MdUnarchive } from "react-icons/md";
import { Tooltip } from "antd";
import WorkersDetailsModal from "../worker-details-modals/WorkerDetailsModal";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  dynamicSet,
  getMyOrganization,
  getOrganizationAdminRequest,
  Organization,
  upsertOrganizationAdminClear } from
"@src/redux";
import { IoCallOutline } from "react-icons/io5";
import { useCheckPageComponentAccess } from "@src/hooks/index";
import { useLocation, useNavigate, useParams } from "react-router-dom";

interface WorkersDetailsCardProps {
  worker: Organization;
}
var pluralize = require("pluralize");

const WorkersDetailsCard: React.FC<WorkersDetailsCardProps> = ({ worker }) => {
  const [mutationType, setMutationType] = useState<"edit" | "add">("edit");
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const { result: myOrgResult } = useSelector(getMyOrganization);
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  let levelName: string =
  myOrgResult?.level?.childLevelList?.[0].name || "";

  const [formType, setFormType] = useState<
    "edit_worker" |
    "edit_admin" |
    "delete_worker" |
    "archive_worker" |
    "un_archive_worker">(
    "edit_worker");

  const onClickToOpen = (
  type:
  "edit_worker" |
  "edit_admin" |
  "delete_worker" |
  "archive_worker" |
  "un_archive_worker") =>
  {
    setFormType(type);
    setModalVisible(true);
    setMutationType("edit");
    if (type === "edit_admin") {
      dispatch(getOrganizationAdminRequest({ id: worker?.id || "" }));
    }
  };

  const onCancel = () => {
    setModalVisible(false);
  };

  const getModalTitle = (type: string) => {
    switch (type) {
      case "delete_worker":
        return `Delete ${pluralize.singular(levelName || "")}`;
      case "archive_worker":
        return `Archive ${pluralize.singular(levelName || "")}`;
      case "un_archive_worker":
        return `Un Archive ${pluralize.singular(levelName || "")}`;
      case "edit_worker":
        return `Edit ${pluralize.singular(levelName)}`;
      case "edit_admin":
        return `${worker?.shortName} - Edit Admin`;
      default:
        return "Edit";
    }
  };

  const handleRedirectNextLevel = () => {
    dispatch(
      dynamicSet("get_organization_level", {
        organizationLevel: worker?.level?.childLevelList?.[0].name
      })
    );
    navigate(`/settings/org/${worker?.id}`, {
      state: {
        breadCrumbs:
        state?.breadCrumbs?.length > 0 ?
        [
        ...state?.breadCrumbs,
        {
          name: `${worker?.name} - ${worker?.level?.childLevelList?.[0].name}`,
          id: worker?.id
        }] :

        [
        {
          name: `${worker?.name} - ${worker?.level?.childLevelList?.[0].name}`,
          id: worker?.id
        }]

      }
    });
  };

  const hasChildLevel = worker?.level?.childLevelList && worker?.level?.childLevelList?.length > 0;

  return (
    <div>
      <div className={`worker-card-container ${worker?.isArchived ? "worker-card-archived" : ""}`}>
        <div className="worker-card-header">
          <div className="worker-card-header-left">
            <div className="worker-avatar">
              {worker?.name?.charAt(0)?.toUpperCase() || "W"}
            </div>
            <span
              className="worker-card-title"
              style={{ cursor: hasChildLevel ? "pointer" : "default" }}
              onClick={hasChildLevel ? handleRedirectNextLevel : () => {}}>
              {worker?.name}
            </span>
          </div>
          <div className="icons-container">
            {useCheckPageComponentAccess("delete_child_organization_action") &&
            <Tooltip title="Delete">
              <button className="worker-action-btn worker-action-red" onClick={() => onClickToOpen("delete_worker")}>
                <AiFillDelete />
              </button>
            </Tooltip>}

            {worker?.isArchived &&
            useCheckPageComponentAccess("archive_child_organization_action") ?
            <Tooltip title="Un Archive">
              <button className="worker-action-btn worker-action-green" onClick={() => onClickToOpen("un_archive_worker")}>
                <MdUnarchive />
              </button>
            </Tooltip> :
            useCheckPageComponentAccess("archive_child_organization_action") ?
            <Tooltip title="Archive">
              <button className="worker-action-btn worker-action-pink" onClick={() => onClickToOpen("archive_worker")}>
                <MdArchive />
              </button>
            </Tooltip> : null}

            {useCheckPageComponentAccess("admin_child_organization_action") &&
            <Tooltip title="Admin">
              <button className="worker-action-btn worker-action-purple" onClick={() => onClickToOpen("edit_admin")}>
                <FaUser />
              </button>
            </Tooltip>}

            {useCheckPageComponentAccess("update_child_organization_action") &&
            <Tooltip title="Edit">
              <button className="worker-action-btn worker-action-blue" onClick={() => onClickToOpen("edit_worker")}>
                <AiFillEdit />
              </button>
            </Tooltip>}
          </div>
        </div>
        <div className="worker-card-body">
          <div
            className="worker-info-chip"
            style={{ cursor: hasChildLevel ? "pointer" : "default" }}
            onClick={hasChildLevel ? handleRedirectNextLevel : () => {}}>
            <span className="worker-chip-icon worker-chip-user"><FaUser /></span>
            <span className="worker-details-text">{worker?.shortName}</span>
          </div>
          <div className="worker-info-chip">
            <span className="worker-chip-icon worker-chip-phone"><IoCallOutline /></span>
            <span className="worker-details-text">
              {typeof worker?.mobile === "object" ? worker?.mobile?.number : worker?.mobile}
            </span>
          </div>
          {worker?.email &&
          <div className="worker-info-chip">
            <span className="worker-chip-icon worker-chip-mail"><MailOutlined /></span>
            <span className="worker-details-text">{worker?.email}</span>
          </div>}
        </div>
      </div>
      <WorkersDetailsModal
        visible={modalVisible}
        mutationType={mutationType}
        onCancel={onCancel}
        formType={formType}
        title={getModalTitle(formType)}
        setModalVisible={setModalVisible}
        worker={worker} />
      
    </div>);

};

export default WorkersDetailsCard;